import { render, staticRenderFns } from "./Bankerror.vue?vue&type=template&id=0a63708c&"
import script from "./Bankerror.vue?vue&type=script&lang=js&"
export * from "./Bankerror.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports